import { defineSlotRecipe } from '@chakra-ui/react';
import { tabsAnatomy } from '@chakra-ui/react/anatomy';

import { tabsIndicatorOffsetY, tabsIndicatorThickness, tabsListBorderWidth } from './tabs.kds';

/** KDS Tabs — overrides Chakra `line` variant only. */
export const tabsSlotRecipe = defineSlotRecipe({
  slots: tabsAnatomy.keys(),
  variants: {
    variant: {
      line: {
        list: {
          borderColor: 'neutral.100',
          _horizontal: {
            borderBottomWidth: tabsListBorderWidth,
          },
        },
        trigger: {
          color: 'neutral.500',
          fontWeight: 'normal',
          textStyle: 'default.regular',
          _selected: {
            color: 'colorPalette.500',
            fontWeight: 'medium',
            '--indicator-thickness': tabsIndicatorThickness,
            '--indicator-offset-y': tabsIndicatorOffsetY,
            '--indicator-color': 'colors.colorPalette.500',
          },
          _disabled: {
            color: 'neutral.250',
            opacity: 1,
          },
        },
      },
    },
  },
});
